"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    base64ToArrayBuffer: ()=>base64ToArrayBuffer,
    convertPCM16ToBase64: ()=>convertPCM16ToBase64,
    convertPCM16ToFloat32: ()=>convertPCM16ToFloat32,
    floatTo16BitPCM: ()=>floatTo16BitPCM
});
function floatTo16BitPCM(float32Array) {
    const int16Array = new Int16Array(float32Array.length);
    for(let i = 0; i < float32Array.length; i++){
        const value = Math.max(-1, Math.min(1, float32Array[i]));
        int16Array[i] = value < 0 ? 0x8000 * value : 0x7fff * value;
    }
    return int16Array;
}
function convertPCM16ToBase64(pcm16Array) {
    let binaryString = '';
    for(let i = 0; i < pcm16Array.length; i++){
        const value = pcm16Array[i];
        binaryString += String.fromCharCode(0xff & value, value >> 8 & 0xff);
    }
    return btoa(binaryString);
}
function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for(let i = 0; i < len; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes.buffer;
}
function convertPCM16ToFloat32(pcm16Array) {
    const float32Array = new Float32Array(pcm16Array.length);
    for(let i = 0; i < pcm16Array.length; i++)float32Array[i] = pcm16Array[i] / 32768;
    return float32Array;
}
exports.base64ToArrayBuffer = __webpack_exports__.base64ToArrayBuffer;
exports.convertPCM16ToBase64 = __webpack_exports__.convertPCM16ToBase64;
exports.convertPCM16ToFloat32 = __webpack_exports__.convertPCM16ToFloat32;
exports.floatTo16BitPCM = __webpack_exports__.floatTo16BitPCM;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "base64ToArrayBuffer",
    "convertPCM16ToBase64",
    "convertPCM16ToFloat32",
    "floatTo16BitPCM"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
